'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AuthenticationLogin = require('./AuthenticationLogin');

var _AuthenticationLogin2 = _interopRequireDefault(_AuthenticationLogin);

var _AuthenticationSite = require('./AuthenticationSite');

var _AuthenticationSite2 = _interopRequireDefault(_AuthenticationSite);

var _SiteStorageManager = require('./SiteStorageManager');

var _SiteStorageManager2 = _interopRequireDefault(_SiteStorageManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthenticationManager = function (_React$Component) {
  (0, _inherits3.default)(AuthenticationManager, _React$Component);

  function AuthenticationManager(props) {
    (0, _classCallCheck3.default)(this, AuthenticationManager);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AuthenticationManager.__proto__ || (0, _getPrototypeOf2.default)(AuthenticationManager)).call(this, props));

    _this.loadSite = function () {
      // if set initially from prop in constructor
      if (_this.state.site) {
        // do not store in local storage if set from prop
        _this.setState({
          isReady: true
        });

        return;
      }

      // attempt to load site from local storage for auto-login
      var site = _SiteStorageManager2.default.get();
      if (site) {
        _this.onSiteSuccess(site);
      } else {
        // load authentication site screen
        _this.setState({
          isReady: true
        });
      }
    };

    _this.onSiteSuccess = function (site) {
      // Store site on local storage for auto-login on reload
      _SiteStorageManager2.default.set(site);

      _this.setState({
        isReady: true,
        site: site
      });
    };

    _this.onResetSite = function () {
      _SiteStorageManager2.default.clear();

      _this.setState({
        site: undefined
      });
    };

    _this.onAuthenticated = function (memberHash, memberId, companyName) {
      _this.props.onAuthenticationSuccess({ memberHash: memberHash, memberId: memberId, companyName: companyName, site: _this.state.site });
    };

    _this.state = {
      isReady: false,
      site: props.site
    };
    return _this;
  }

  (0, _createClass3.default)(AuthenticationManager, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // embedded mode
      if (!this.props.isStandalone) {
        this.props.onAuthenticationSuccess(null); // auth credential data should be on store

        this.setState({
          isReady: true
        });

        return;
      }

      this.loadSite();
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.state.isReady) {
        return null;
      }

      if (this.props.isAuthenticated) {
        return this.props.children;
      }

      if (this.state.site) {
        return _react2.default.createElement(_AuthenticationLogin2.default, {
          site: this.state.site,
          onResetSite: this.onResetSite,
          onAuthenticated: this.onAuthenticated
        });
      }

      return this.props.manageAuthSite ? _react2.default.createElement(this.props.manageAuthSite, { onSiteLogin: this.onSiteSuccess }) : _react2.default.createElement(_AuthenticationSite2.default, { onSiteLogin: this.onSiteSuccess });
    }
  }]);
  return AuthenticationManager;
}(_react2.default.Component);

AuthenticationManager.propTypes = {
  site: _propTypes2.default.string,
  isAuthenticated: _propTypes2.default.bool.isRequired,
  isStandalone: _propTypes2.default.bool.isRequired,
  onAuthenticationSuccess: _propTypes2.default.func.isRequired
};

exports.default = AuthenticationManager;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/authentication/AuthenticationManager.js
// module id = 320
// module chunks = 10